var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCast = function SvgCast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.723 15.149a5.31 5.31 0 0 1 4.245 4.245.6.6 0 0 1-1.18.22 4.11 4.11 0 0 0-3.284-3.285.6.6 0 0 1 .22-1.18m-.1 3.755a.6.6 0 0 1 0 1.2h-.01a.6.6 0 1 1 0-1.2zM19.556 3.845a2.483 2.483 0 0 1 2.482 2.483v11.294a2.48 2.48 0 0 1-2.482 2.481h-5.647a.6.6 0 1 1 0-1.2h5.647a1.28 1.28 0 0 0 1.282-1.281V6.328a1.285 1.285 0 0 0-1.282-1.284H4.497a1.284 1.284 0 0 0-1.284 1.284V8.21a.6.6 0 1 1-1.199 0V6.328a2.484 2.484 0 0 1 2.483-2.483zM2.677 11.377a9.07 9.07 0 0 1 8.063 8.063.6.6 0 0 1-1.194.127 7.87 7.87 0 0 0-6.996-6.996.6.6 0 0 1 .127-1.194"
  })));
};
export default SvgCast;